import React, {SVGProps} from 'react';

function Arrow2SVG(props: SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 1L5.25 5.25L1 1" stroke="#5B77CB" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>

    );
}

export default Arrow2SVG;